"use strict";

document.addEventListener('DOMContentLoaded', function () {
  $('.quick-view').click(function (e) {
    console.log(this);
    var id = $(this).data('expand-id');
    var expandItem = document.getElementById(id);
    $(this).toggleClass('open');
    $(expandItem).toggleClass('expanded');
  });
  setTimeout(function () {
    // GeoInput and ClearButton functionality
    var input = document.getElementById('geoInput');
    var clearBtn = document.getElementById('clearButton');
    if (input && clearBtn) {
      // Ensure the elements exist
      function toggleClearButton() {
        clearBtn.style.display = input.value.length > 0 ? 'flex' : 'none';
      }
      function clearInput() {
        input.value = '';
        input.focus();
        toggleClearButton();
      }
      input.addEventListener('input', toggleClearButton);
      clearBtn.addEventListener('click', clearInput);
    }
  }, 1000);
});
setTimeout(function () {
  var locationBtnNew = document.querySelector('.custom-search-section-new__input-box .custom-search-section-new__locateme');
  var inputBox = document.getElementById('geoSearchBarInput');
  var locationDiv = document.querySelector('.custom-search-section-new__locateme');
  var searchSection = document.querySelector('.custom-search-section-new');
  if ("geolocation" in navigator && "permissions" in navigator) {
    navigator.permissions.query({
      name: 'geolocation'
    }).then(function (permissionStatus) {
      console.log("Geolocation permission status: ".concat(permissionStatus.state));
      if (permissionStatus.state === "granted") {
        inputBox.addEventListener('focus', function () {
          locationBtnNew.classList.add('visible');
          searchSection.classList.add("useMyLocation");
        });
        document.addEventListener('click', function (event) {
          if (!inputBox.contains(event.target) && !locationDiv.contains(event.target)) {
            locationDiv.classList.remove('visible');
            searchSection.classList.remove("useMyLocation");
          }
        });
        console.log("Geolocation access granted.");
      } else if (permissionStatus.state === "prompt") {
        console.log("Geolocation access will prompt.");
        locationBtnNew.style.display = 'none';
      } else if (permissionStatus.state === "denied") {
        locationBtnNew.style.display = 'none';
        console.log("Geolocation access denied.");
      }
      permissionStatus.onchange = function () {
        console.log("Geolocation permission status changed to: ".concat(permissionStatus.state));
      };
    });
  } else {
    console.log("Geolocation or Permissions API is not supported by this browser.");
  }
}, 1000);

// Modal JavaScript from Bulma.io
document.addEventListener('DOMContentLoaded', function () {
  // Functions to open and close a modal
  function openModal($el) {
    $el.classList.add('is-active');
  }
  function closeModal($el) {
    $el.classList.remove('is-active');
  }
  function closeAllModals() {
    (document.querySelectorAll('.modal') || []).forEach(function ($modal) {
      closeModal($modal);
    });
  }

  // Add a click event on buttons to open a specific modal
  (document.querySelectorAll('.js-modal-trigger') || []).forEach(function ($trigger) {
    var modal = $trigger.dataset.target;
    var $target = document.getElementById(modal);
    $trigger.addEventListener('click', function () {
      openModal($target);
    });
  });

  // Add a click event on various child elements to close the parent modal
  (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(function ($close) {
    var $target = $close.closest('.modal');
    $close.addEventListener('click', function () {
      closeModal($target);
    });
  });

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllModals();
    }
  });
});